import { Divider, Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import { type LeadQualificationQuestion } from "../../types/lead.types.ts"
import { TextInput } from "../../../../components/Input/TextInput.tsx"

const { Text } = Typography

interface LeadViewQualificationQuestionsProps {
  qualificationQuestions: LeadQualificationQuestion[]
}

/**
 * A read-only, input-shaped reading of each answer (disabled, never
 * submitted) — every configured question stays visible whether or not it has
 * an answer, so scanning what's missing doesn't require opening Edit first.
 * The real, writable fields of the same shape live in the workspace card's
 * own `QualificationEditor` (`LeadQualificationCard`), reached via Edit.
 */
export function LeadViewQualificationQuestions({
  qualificationQuestions
}: LeadViewQualificationQuestionsProps) {
  const { t } = useTranslation()

  return (
    <Flex vertical>
      {qualificationQuestions.map((q, index) => (
        <div key={index}>
          {index > 0 && <Divider className={"my-2"} />}
          <Flex gap={"middle"} align={"start"} justify={"space-between"}>
            <Text className={"min-w-0 pt-1"}>{q.question}</Text>
            <TextInput
              disabled
              readOnly
              value={q.answer?.trim() || undefined}
              placeholder={t("leadWorkspace.cards.qualification.placeholder")}
              className={"w-64 max-w-full shrink-0"}
            />
          </Flex>
        </div>
      ))}
    </Flex>
  )
}
